import React, { useEffect, useState } from "react";
import { getComaPrice } from "../module/simple";

const LocationBasedPrice = ({ item, props, variant }) => {
  const [displayPrice, setDisplayPrice] = useState("");
  const [itemBasedOnPage, setItemBasedOnPage] = useState(null);

  const location = localStorage.getItem("location") || "";
  const pageName = typeof window !== "undefined" ? window.location.pathname : "";

  useEffect(() => {
    if (!item) return;
    let currentItem;
    const products = Array.isArray(item) ? item : item?.products;

    if (pageName.includes("allcars")) {
      currentItem = products?.[0] || item;
    } else if (pageName.includes("car")) {
      currentItem = variant ? (products?.[0] || item) : item;
    } else {
      currentItem = products?.[0] || item;
    }
    setItemBasedOnPage(currentItem);

    // --- Location-based pricing ---
    const { price, tn_price, tg_price } = currentItem || {};

    const locationPriceMap = {
      Bengaluru: price,
      Mysore: price,
      Chennai: tn_price,
      Hydrabad: tg_price,
    };

    const selectedPrice = locationPriceMap[location] ?? price;

    // --- Handle "Price to be announced" ---
    const finalPrice =
      [price, tn_price, tg_price].includes(0) ||
      selectedPrice === 0 ||
      selectedPrice == null
        ? "Price to be announced"
        : selectedPrice;

    setDisplayPrice(finalPrice);
  }, [item, variant, location, pageName]);

  if (!itemBasedOnPage) return null;

  const formattedPrice =
    typeof displayPrice === "number"
      ? `₹ ${getComaPrice(displayPrice)} /-`
      : displayPrice;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="hb_8g">{formattedPrice}</div>

      <div
        className="hb_8h"
        onClick={() =>
          props.setState({
            enquiryPopup: {
              car: itemBasedOnPage.name,
              type: 5,
            },
          })
        }
      >
        Ex-showroom price
      </div>
    </div>
  );
};

export default LocationBasedPrice;
